module.exports = __webpack_public_path__ + "static/logo-dummy-1a3d3148b492392da6cc6431c4040747.png";